/**
 * @fileoverview
 * Textarea Field Component - Reusable textarea component
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Component, Input, Optional, Self, ChangeDetectionStrategy, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  FormsModule,
  NgControl,
} from '@angular/forms';

@Component({
  selector: 'app-textarea-field',
  standalone: true,
  imports: [CommonModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './textarea-field.component.html',
  styleUrl: './textarea-field.component.css',
})
export class TextareaFieldComponent implements ControlValueAccessor {
  private cdr = inject(ChangeDetectorRef);

  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() labelClass: string = '';
  @Input() isReadOnly: boolean = false;
  @Input() showAsterisk: boolean = false;
  @Input() rows: number = 4;
  isDisabled: boolean = false;
  value: string = '';

  onChange = (value: string) => {};
  onTouched = () => {};

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  writeValue(value: string | null | undefined): void {
    this.value = value ?? '';
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}

